import styled from 'styled-components';

export const StyledWrapperButtons = styled.div`
  display: flex;
  gap: 1.6rem;
  justify-content: center;
  flex-wrap: wrap;
`;
